import { render, staticRenderFns } from "./PaymentHistoryDownload.vue?vue&type=template&id=46fb6070&scoped=true"
import script from "./PaymentHistoryDownload.vue?vue&type=script&lang=js"
export * from "./PaymentHistoryDownload.vue?vue&type=script&lang=js"
import style0 from "./PaymentHistoryDownload.vue?vue&type=style&index=0&id=46fb6070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fb6070",
  null
  
)

export default component.exports